import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PayoutDisbursal } from "../../types/payouts";

type Props = {
  open: boolean;
  onClose: () => void;
  disbursal: PayoutDisbursal | null;
};

const TransactionDetailsModal: React.FC<Props> = ({ open, onClose, disbursal }) => {
  const notes = disbursal?.extraDetails?.notes;
  const receipts = disbursal?.extraDetails?.receipts || [];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Transaction Details
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {notes ? (
          <Box mb={3}>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              Notes
            </Typography>
            <Typography variant="body2">{notes}</Typography>
          </Box>
        ) : null}

        {receipts.length ? (
          <Box>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              Receipts
            </Typography>
            <Stack spacing={2}>
              {receipts.map((receipt) => (
                <Box key={receipt} sx={{ border: "1px solid #e5e7eb", borderRadius: 2, p: 2 }}>
                  <Typography variant="body2" sx={{ wordBreak: "break-all", mb: 1 }}>
                    {receipt}
                  </Typography>
                  <Link href={`http://localhost:4030${receipt}`} target="_blank" rel="noreferrer">
                    Open receipt
                  </Link>
                </Box>
              ))}
            </Stack>
          </Box>
        ) : null}

        {!notes && !receipts.length ? (
          <Typography variant="body2">No additional details available for this transaction.</Typography>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default TransactionDetailsModal;
